import React from 'react';
import { useSelector } from 'react-redux';

interface AccordionProps {
  extrastyling:boolean;
  title: any;
  children: React.ReactNode;
  isOpen: boolean;
  onClick: () => void;
  headerId?: string;
  panelId?: string;
  nonCollapsible?: boolean;
}

const Accordion: React.FC<AccordionProps> = ({
  title,
  children,
  isOpen,
  onClick,
  headerId,
  panelId,
  extrastyling=false,
  nonCollapsible = false,
}) => {
  const { contentfulData } = useSelector(
    (state: { contentful: any }) => state.contentful
  );

  const { assets } = contentfulData || {};

  const handleKeyDown = (e: React.KeyboardEvent<HTMLButtonElement>) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      onClick();
    }
  };

  let backgroundClass = 'bg-white';
  if (isOpen) {
    backgroundClass = extrastyling ? 'bg-[#FAFAFA]' : 'bg-gray-100';
  }

  return (
    <div
      className={`border-t border-b border-gray-300 transition-colors duration-200 mb-4
        ${backgroundClass}
      `}
    >
      {/* Header */}
      <h3 className="m-0">
        {nonCollapsible ? (
          <span
            id={headerId}
            className="w-full flex justify-between items-center text-left px-4 py-5 text-lg font-semibold"
          >
            {title}
          </span>
        ) : (
          <button
            type="button"
            onClick={onClick}
            onKeyDown={handleKeyDown}
            id={headerId}
            aria-controls={panelId}
            aria-expanded={isOpen}
            className={`w-full flex justify-between items-center text-left px-4 py-5 text-lg
            ${isOpen ? 'font-semibold' : 'font-normal'}
            focus:outline-none focus:ring-2 focus:ring-gray-200 focus:ring-offset-2
          `}
          >
            <span>{title}</span>
            <img
              src={isOpen ? assets?.up_arrow : assets?.down_arrow}
              alt=""
              aria-hidden="true"
              className="w-5 h-5 transition-transform duration-200"
            />
          </button>
        )}
      </h3>

      {/* Content */}
      <section
        id={panelId}
        aria-labelledby={headerId}
        aria-label="Accordion content"
        hidden={!isOpen}
        // className={`transition-all duration-300 ${isOpen ? 'px-6 pb-6' : ''}`}
      >
        <div className="text-gray-700 leading-relaxed">{children}</div>
      </section>
    </div>
  );
};

export default Accordion;
